<!--Controls Section------------------------------------------------------------------------------------------------------------------------------>
<br>
<div class="body">
    <table id="optionsTable">

        <tr>
            <td>
                <select class="left custom-select tableInput" [(ngModel)]="batchSelect" (ngModelChange)="batchIsSelected = true">
                    <option class="custom-option" selected hidden ngValue="">Select Historic Batch</option>
                    <option class="custom-option" *ngFor="let batch of historicBatches" [ngValue]="batch.batchId">{{batch.batchName}}</option>
                </select>
            </td>
            <td><button mat-raised-button color="primary" [disabled]="!batchIsSelected" (click)="getBatch(batchSelect);">Load Users</button></td>
        </tr>

        <tr><td colspan="2" height="5">&nbsp;</td></tr>

        <tr>
            <td><input class="tableInput" type="text" [value]="fileName" placeholder=" ..." readonly></td>
            <td><button mat-raised-button color="primary" (click)="uploader.click(); batchDescription=''">Open File</button></td>
        </tr>

        <tr><td><button mat-raised-button color="primary" class="left" [disabled]="disableLoadFile" (click)="submitCsvData();">Load</button></td></tr>

    </table>
    <input hidden type="file" #uploader (change)="uploadFile($event)" />
</div>
<!--Table Section------------------------------------------------------------------------------------------------------------------------------>
<div class="tableContainer">
    <div class="responseContainer">
        <app-response-text
            class="page-message"
            [lambdaMessage]="lambdaMessage"
            [lambdaError]="lambdaError">
        </app-response-text>
    </div>

    <app-data-grid
        [(data)]="filteredData"
        [headerTemplate]="header"
        [viewTemplate]="batchView"
        [columnNames]="['Username', 'Extension', 'Status', 'Message']"
        [spacing]="[1, 1, 1, 1, 0.001]"
        [itemsPerPage]="inputItemsPerPage"
        [allowDelete]="false"
        [allowEdit]="false"
        [allowAdd]="false"
    >
        <ng-template #batchView let-item>
            <td><span class="left-text">{{item.username}}</span></td>
            <td><span class="left-text">{{item.extension}}</span></td>
            <td>
                <div *ngIf="item.status == 'unprocessed'">Unprocessed</div>
                <div *ngIf="item.status == 'success'" class="green-text">Created</div>
                <div *ngIf="(item.status != 'unprocessed') && (item.status != 'success')" class="red-text">{{item.status}}</div>
            </td>
            <td class="overflow-container"><div class="left-text" *ngIf="item.hasOwnProperty('message')">{{item.message}}</div></td>
        </ng-template>

        <ng-template #header>
            <div class="top" fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                <input type="text" class="search" placeholder="search..." [(ngModel)]="searchString" (ngModelChange)="applyFilter()">
                <div>
                    <app-toggle-switch id="toggle" [(switch)]="showAll" (switchChange)="applyFilter();" [falseColor]="'#ff3b3b'"></app-toggle-switch>
                    <span class="headerLabel" *ngIf="showAll">All Rows</span>
                    <span class="headerLabel" *ngIf="!showAll">Unprocessed</span>
                </div>
                <div>
                    Size: {{batchData.length}}
                </div>
                <div>
                    Success: {{successCount}}
                </div>
                <div>
                    Error: {{errorCount}}
                </div>
                <div>
                    <span>Items per page:&nbsp;</span> 
                    <input id="headerInput" pattern="\d*" type="number" min="1" max="200" 
                    [(ngModel)]="itemsPerPage"
                    (focusout)="cleanField()" 
                    (keyup)="enforceMaxNumber()"
                    (change)="enforceMaxNumber()">
                </div>
            </div>
        </ng-template> 

    </app-data-grid>

    <div fxLayout.xs="row" fxLayoutGap="10px" fxLayoutAlign="center">
        <button mat-raised-button color="accent" (click)="cancelSelectedBatch();" [disabled]="disableProcessBatch">Cancel</button>
        <button mat-raised-button color="primary" (click)="processData();" [disabled]="disableProcessBatch">Process Batch</button>
    </div>

</div>